import styles from "./OfferTakeoverSkeleton.module.scss";

const OfferTakeoverSkeleton = () => {
  return (
    <div className={styles.skeletonContainer}>
      {/* Close button skeleton */}
      <div className={styles.closeButton} />

      {/* Hero image skeleton */}
      <div className={styles.heroImage} />

      {/* Header section */}
      <div className={styles.header}>
        <div className={styles.title} />
        <div className={styles.subtitle} />
      </div>

      {/* Section title */}
      <div className={styles.sectionTitle} />

      {/* Offer cards grid */}
      <div className={styles.offerGrid}>
        {[1, 2, 3, 4].map((i) => (
          <div key={`skeleton-offer-${i}`} className={styles.offerCard}>
            <div className={styles.cardImage} />
            <div className={styles.cardContent}>
              <div className={styles.cardTitle} />
              <div className={styles.cardSubtitle} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OfferTakeoverSkeleton;
